<template>
  <!--
    AT-API-020-H1 (doc 34/01 §3.3, doc 34/03 §3) -- the Tutor refused the
    ACTION a message carried: the course's actions are no longer what Borna
    had read. Nothing was recorded or charged, and nothing is sent again on
    its own. The message stays on screen as it was written (its text, its
    picture); this notice, in the Composer's `notice` slot like the credit
    warning, puts the choice to the Student:

      «ارسال به‌صورت پرسش معمولی»  send that same message once, with no action
      «فعلاً نه»                    send nothing; the message stays unsent

    Presentation only: both controls report to the host, which owns the
    store. No approved prototype exists for this notice; it borrows the
    credit warning's own measured surface (same slot, same box, same type).
  -->
  <div
    class="ai-tutor-action-recovery"
    role="status"
    data-testid="ai-tutor-action-recovery"
    :aria-label="$t('aiTutorSetup.chat.actionRecovery.label')"
  >
    <span class="ai-tutor-action-recovery__copy">
      <strong>{{ $t('aiTutorSetup.chat.actionRecovery.title') }}</strong>
      <small>{{ $t('aiTutorSetup.chat.actionRecovery.body') }}</small>
    </span>
    <span class="ai-tutor-action-recovery__actions">
      <button
        type="button"
        class="ai-tutor-action-recovery__send"
        data-testid="ai-tutor-action-recovery-send"
        :disabled="disabled"
        @click="$emit('send-plain')"
      >
        {{ $t('aiTutorSetup.chat.actionRecovery.sendPlain') }}
      </button>
      <button
        type="button"
        class="ai-tutor-action-recovery__later"
        data-testid="ai-tutor-action-recovery-later"
        @click="$emit('dismiss')"
      >
        {{ $t('aiTutorSetup.chat.actionRecovery.later') }}
      </button>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ChatActionRecovery',
  props: {
    // A send is not possible right now (something is in flight, the chat is
    // not ready, or the known credit balance is zero): only the send choice
    // is held back -- declining is always possible.
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
// Rendered in the composer's `notice` slot, like `.ai-tutor-credit-warning`:
// that area spaces it from the composer and it spans the composer's width.
.ai-tutor-action-recovery {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  box-sizing: border-box;
  justify-self: stretch;
  width: 100%;
  margin: 0;
  padding: 10px 12px;
  border: 1px solid $borna-indigo-300;
  border-radius: 13px;
  background: $borna-indigo-50;
  color: $borna-ink;
  font-size: 14px;
  line-height: 1.75;
}

.ai-tutor-action-recovery__copy {
  display: grid;
  flex: 1 1 240px;
  gap: 2px;
  min-width: 0;

  strong {
    font-size: 14px;
    font-weight: 700;
  }

  small {
    color: $borna-text;
    font-size: 11px;
    line-height: 1.75;
  }
}

.ai-tutor-action-recovery__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.ai-tutor-action-recovery__send,
.ai-tutor-action-recovery__later {
  min-height: 42px;
  padding: 0 14px;
  border-radius: 12px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.75;
  cursor: pointer;

  @include borna-compact {
    min-height: 44px;
  }
}

.ai-tutor-action-recovery__send {
  border: 1px solid $borna-indigo-600;
  background: $borna-indigo-600;
  color: #fff;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.ai-tutor-action-recovery__later {
  border: 1px solid $borna-indigo-300;
  background: $borna-surface;
  color: $borna-indigo-900;
}
</style>
